import { Dictionary } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import { EasyPricingViewModel } from '@shared/models/easy-pricing.model';
import { RecentPurchase } from '@usf/list-types';
import {
  recentPurchaseAdapter,
  selectRecentPurchaseState,
} from '@usf/ngrx-list';
import { IEasyPricingState, selectEasyPricingState } from '@usf/ngrx-pricing';
import { createEasyPricingViewModel } from './helpers/easy-pricing-helpers';
import { selectCustomerEntities } from '@app/ngrx-customer/store';
import { Customer } from '@usf/customer-types';

export const selectEasyPricingViewModels = createSelector(
  selectEasyPricingState,
  recentPurchaseAdapter.getSelectors(selectRecentPurchaseState).selectEntities,
  selectCustomerEntities,
  (
    easyPricingState: IEasyPricingState,
    recentPurchaseEntities: Dictionary<RecentPurchase>,
    customerEntities: Dictionary<Customer>,
  ): Dictionary<EasyPricingViewModel> => {
    const viewModels: Dictionary<EasyPricingViewModel> = {};

    Object.keys(easyPricingState.entities).forEach(key => {
      const easyPricing = easyPricingState.entities[key];
      const recentPurchase = recentPurchaseEntities[key];

      const viewModel = createEasyPricingViewModel(
        easyPricing,
        recentPurchase,
        customerEntities,
      );
      if (viewModel) {
        viewModels[key] = viewModel;
      }
    });

    return viewModels;
  },
);
